module.exports = __webpack_public_path__ + "media/stencils/smt_stencils_frameless-35da1e14.png";